'use strict';
module.exports = require('../../full/object/define-property');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/define-property.js
// module id = 234
// module chunks = 13